export default "__VITE_ASSET__DUz9jPEP__"